export default __webpack_public_path__ + "static/media/kai-pilger.1c61a6af.jpg";